import type { IStatus } from "@shared/ui";
import "./integration-status-filter-options.scss";

export const INTEGRATION_STATUS_FILTER_OPTIONS: IStatus[] = [
  {
    id: "SENT",
    status: "Отправлено",
    icon: <span className="integration-status-icon integration-status-icon--sent" />,
  },
  {
    id: "ERROR",
    status: "Ошибка взаимодействия",
    icon: <span className="integration-status-icon integration-status-icon--error" />,
  },
  {
    id: "ACCEPTED",
    status: "Принято",
    icon: <span className="integration-status-icon integration-status-icon--accepted" />,
  },
  {
    id: "REJECTED",
    status: "Не принято",
    icon: <span className="integration-status-icon integration-status-icon--rejected" />,
  },
  {
    id: "NONE",
    status: "Нет статуса",
    icon: <span className="integration-status-icon integration-status-icon--none" />,
  },
];
